<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs6><h1 class="headline mt-2">Ticket List</h1></v-flex>
      <v-flex class="text-xs-right" xs6>
        <span>
          <v-btn
            :loading="exportloading"
            class="ma-0 mb-0"
            color="grey"
            outline
            @click="showExportTicket = true"
          >
            <em class="fas fa-file-export mr-1" /> {{ $t('export') }}
          </v-btn>
        </span>

        <v-btn :loading="loading" color="primary" depressed @click="showSearch = true">
          <v-icon class="mr-1">search</v-icon>
          Search
        </v-btn>
        <v-btn :loading="loading" color="primary" icon @click="onSearch">
          <em class="fas fa-sync-alt" />
        </v-btn>
        <v-dialog v-model="showSearch" max-width="600" persistent scrollable>
          <DialogSearchTicket
            v-if="showSearch"
            v-model="filter"
            @close="showSearch = false"
            @onSearch="onSearch"
          />
        </v-dialog>
      </v-flex>
    </v-layout>
    <div class="mb-2">
      <v-chip v-for="(item, k) in showFilter" :key="k" color="blue" dark>{{ item }}</v-chip>
    </div>

    <v-layout wrap>
      <!-- <v-flex xs12>
        <div
          style="float: right; font-weight: 700; font-size: large; padding-top: 14px"
          class="mb-3"
        >

        </div>
      </v-flex> -->
      <v-flex>
        <div style="display: flex; align-items: center">
          <!-- <div v-if="isShowSelectAll && showSelectAllCloseTicketButton" class="pb-2">
            <v-btn
              :disabled="selectedTicket && selectedTicket.length == 0"
              color="primary"
              depressed
              outline
              @click="handleCloseSelectedTicket"
              >Close Ticket
            </v-btn>
          </div> -->
          <div
            v-if="
              isShowSelectAll &&
              showSelectAllTransferTicketButton &&
              !['qa', 'reporter'].includes($store.state.privilege.role)
            "
            class="pb-2"
          >
            <v-btn
              :disabled="selectedTicket && selectedTicket.length == 0"
              color="primary"
              @click="showDialogSelectAgent = true"
            >
              <v-icon style="width: 24px">swap_horizontal</v-icon>
              &nbsp; Transfer
            </v-btn>
          </div>
          <!-- TODO: Hidden Close Ticket Button -->
          <div
            v-if="isShowSelectAll && ['supervisor'].includes($store.state.privilege.role) && false"
            class="pb-2"
          >
            <v-btn
              :disabled="selectedTicket && selectedTicket.length == 0"
              color="primary"
              @click="showDialogCloseTicket = true"
            >
              {{ $t('close_ticket') }}
            </v-btn>
          </div>
        </div>
      </v-flex>
      <v-flex class="text-xs-center">
        <Pagination
          :key="page"
          v-model="page"
          :limit="limit"
          :total="total"
          @onChange="onChange($event)"
        >
        </Pagination>
      </v-flex>
      <v-flex
        class="text-xs-right"
        style="float: right; font-weight: 700; font-size: large; padding-top: 14px"
      >
        Total : {{ total ? total : 0 }}
      </v-flex>
    </v-layout>

    <template v-if="showTable">
      <v-data-table
        :key="timestamp"
        v-model="selectedTicket"
        :headers="headers"
        :items="ticketFormat"
        :loading="loading"
        :pagination.sync="pagination"
        :select-all="isShowSelectAll && !['qa', 'reporter'].includes($store.state.privilege.role)"
        class="custom-table elevation-1"
        hide-actions
        item-key="id"
      >
        <!-- Name,Email,Phone,Channel , Note, Status, Assign to, Group ,Subgroup -->
        <template #items="props">
          <tr
            :class="{
              grey: props.item.status == 'closed',
              orange: props.item.status == 'pending',
              red: props.item.status == 'cancelled',
              purple: props.item.status == 'cancelled by customer'
            }"
            class="lighten-5"
            @click="handleOpenEditTicket(props.item.id)"
          >
            <td
              v-if="isShowSelectAll && !['qa', 'reporter'].includes($store.state.privilege.role)"
              @click.stop=""
            >
              <v-checkbox
                v-model="props.selected"
                :disabled="
                  props.item.status &&
                  [
                    'closed by system',
                    'closed with survey',
                    'closed without survey',
                    'closed by sales',
                    'cancelled by customer',
                    'cancelled',
                    'closed'
                  ].includes(props.item.status)
                "
                class="ma-0"
                color="primary"
                hide-details
                style="display: inline-block"
              ></v-checkbox>
            </td>
            <td class="d-flex">
              <v-layout row>
                <v-btn
                  v-if="!['reporter'].includes($store.state.privilege.role)"
                  color="primary"
                  icon
                  outline
                  @click.stop="goToLivechat(props.item, props.item.app)"
                >
                  <em class="fas fa-comments" />
                </v-btn>
                <v-btn
                  :loading="loadingHistory"
                  color="primary"
                  icon
                  outline
                  @click.stop="handleShowHistory(props.item.id)"
                >
                  <em class="fas fa-history" />
                </v-btn>
              </v-layout>

              <FormTicketManage
                :key="props.item.id"
                :ref="`editticket_${props.item.id}`"
                v-model="props.item"
                :loading="loading"
                :type="'edit'"
                @editTicket="onEditTicket"
              />
            </td>

            <td>{{ props.item.id }}</td>
            <td>
              <v-chip
                v-if="props.item.status == 'pending'"
                :color="'warning'"
                class="white--text"
                disabled
                small
                >{{ props.item.status }}
              </v-chip>
              <v-chip
                v-else-if="props.item.status == 'closed'"
                :color="'grey'"
                class="white--text"
                disabled
                small
                >{{ props.item.status }}
              </v-chip>
              <v-chip
                v-else-if="props.item.status == 'close by yes sales'"
                :color="'grey'"
                class="white--text"
                disabled
                small
                >{{ props.item.status }}
              </v-chip>
              <v-chip
                v-else-if="props.item.status == 'cancelled'"
                :color="'error'"
                class="white--text"
                disabled
                small
                >{{ props.item.status }}
              </v-chip>
              <v-chip
                v-else-if="props.item.status == 'cancelled by customer'"
                :color="'#fd87ee'"
                class="white--text"
                disabled
                small
                >cancelled by customer
              </v-chip>
              <v-chip
                v-else-if="props.item.status == 'answered'"
                :color="'info'"
                class="white--text"
                disabled
                small
                >{{ props.item.status }}
              </v-chip>
              <v-chip
                v-else-if="props.item.status == 'open'"
                :color="'green'"
                class="white--text"
                disabled
                small
                >{{ props.item.status }}
              </v-chip>
              <v-chip v-else :color="'info'" class="white--text" disabled small
                >{{ props.item.status }}
              </v-chip>
            </td>
            <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
            <td>{{ props.item.customer_page_name }}</td>
            <td>
              <template v-if="props.item.channel == 'facebook'">
                <em class="fas fa-brands fa-facebook" />
              </template>
              <template v-else-if="props.item.channel == 'x'">
                <em class="fas fa-brands fa-x" />
              </template>
              <template v-else-if="props.item.channel == 'pantip'">
                <em class="fas fa-brands fa-pantip" />
              </template>
              <template v-else><em class="fas fa-envelope" style="color: grey" /></template>
            </td>
            <td>
              {{
                props.item.platform_type === 'inbox'
                  ? $t('all_in_one_chat.inbox')
                  : props.item.platform_type === 'page'
                  ? $t('all_in_one_chat.post')
                  : '-'
              }}
            </td>
            <td
              v-if="
                ['closed with survey', 'closed without survey'].includes(props.item.status) &&
                props.item.assignadminid
              "
            >
              {{ props.item.assignadminid || '-' }}
            </td>
            <td v-else>-</td>
            <!-- <td>{{ props.item.transfer_ticket_by || 'system' }}</td> -->
            <td>{{ props.item.assignadminid || '-' }}</td>
            <td>
              <template v-if="props.item.starttime"
                >{{ props.item.starttime | DateFormat('DD/MM/YYYY HH:mm') }}
              </template>
            </td>
            <td>
              <template v-if="props.item.assign_ticket_timestamp"
                >{{ props.item.assign_ticket_timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </template>
            </td>
            <td>
              <template v-if="props.item.adminfirstresponsetime"
                >{{ props.item.adminfirstresponsetime | DateFormat('DD/MM/YYYY HH:mm') }}
              </template>
              <template v-else>-</template>
            </td>
            <!-- <td>
              <template v-if="props.item.endtime">{{
                props.item.endtime | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
            </td> -->
            <td>
              <template
                v-if="props.item.adminfirstresponsetime && props.item.assign_ticket_timestamp"
              >
                {{
                  toTimer(
                    diffSecond(
                      props.item.adminfirstresponsetime,
                      props.item.assign_ticket_timestamp
                    )
                  )
                }}
              </template>
              <template v-else>-</template>
            </td>
            <td>
              <template v-if="props.item.starttime && props.item.endtime">
                {{ toTimer(diffSecond(props.item.endtime, props.item.starttime)) }}
              </template>
              <template v-else>-</template>
            </td>
            <td>{{ props.item.thread_id || '-' }}</td>
            <td>{{ props.item.postid || '-' }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <div class="text-xs-center pt-2">
      <Pagination
        :key="page"
        v-model="page"
        :limit="limit"
        :total="total"
        @onChange="onChange($event)"
      >
      </Pagination>
    </div>

    <ExportGroup
      v-model="showExportTicket"
      :limit="100000"
      :total="total"
      @onExport="exportTicket"
    />

    <v-dialog v-model="showDialogSelectAgent" persistent width="500px">
      <DialogSelectAgent
        v-if="showDialogSelectAgent"
        @close="showDialogSelectAgent = false"
        @selectedAgent="handleTransferTicket"
      />
    </v-dialog>

    <v-dialog v-if="historyData" v-model="showHistory" persistent width="800px">
      <HistoryStatus
        v-if="showHistory"
        v-model="historyData"
        @close="handleCloseHistory"
      ></HistoryStatus>
    </v-dialog>

    <v-dialog v-model="showDialogCloseTicket" persistent width="800px">
      <DialogCloseTicket
        v-if="showDialogCloseTicket"
        @close="showDialogCloseTicket = false"
        @submit="handleCloseTicket"
      />
    </v-dialog>
  </v-container>
</template>

<script>
const FormTicketManage = () => import('./FormTicketManage')

import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import XLSX from 'xlsx'
import Pagination from '@/components/elements/Pagination.vue'
import { notificationNewTicket } from '@/utils/notification'
import ExportGroup from '@/components/elements/ExportGroup.vue'
import ttbApi from '@/api/ttb'
import DialogSearchTicket from './DialogSearchTicket.vue'
import DialogSelectAgent from './DialogSelectAgent.vue'
import HistoryStatus from './HistoryStatus.vue'
import { LOCAL_STORAGE_NAME } from '@/constants/general'
import allInOneChatApi from '@/api/all-in-one-chat'
import DialogCloseTicket from './DialogCloseTicket.vue'
import ticketApi from '@/api/ticket'

const INTERVAL_TICKET = 120000
export default {
  name: 'DashboardTicket',
  components: {
    Pagination,
    ExportGroup,
    DialogSearchTicket,
    FormTicketManage,
    DialogSelectAgent,
    HistoryStatus,
    DialogCloseTicket
  },
  data() {
    return {
      countStatus: {},
      page: 1,
      timestamp: moment().format('x'),
      showSearch: false,
      loadingHistory: false,
      historyData: null,
      showHistory: false,
      filter: {
        id: '',
        subject: '',
        contact_name: '',
        contact_email: '',
        channel: null,
        status: ['pending', 'answered', 'cancelled by customer'],
        group: {
          groupname: 'All',
          id: null
        },
        contact_phone: '',
        sort: {
          text: 'All',
          value: null
        },
        assignadminid: '',
        botreply: null,
        selectedDate: {
          start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD'),
          starttime: null,
          endtime: null
        },
        platform_type: null,
        search_page_id: 'all'
      },
      pagination: {
        sortBy: 'starttime',
        descending: true,
        rowsPerPage: 100
      },
      headers: [
        { text: '', sortable: false },
        { text: 'Ticket ID', value: 'id' },
        { text: 'Status', value: 'status' },
        { text: 'Customer Name', value: 'first_name' },
        { text: 'Page', value: 'page' },
        { text: 'Channel', value: 'channel' },
        { text: 'Platform Type', value: 'platform_type' },
        { text: 'Closed By', value: 'closed_by' },
        // { text: 'Transfer By', value: 'transfer_ticket_by' },
        { text: 'Assign To', value: 'assign_to' },
        { text: 'Start time', value: 'starttime' },
        { text: 'Assign to agent', value: 'starttime_time' },
        { text: 'First Time Response', value: 'adminfirstresponsetime' },
        // { text: 'End Time', value: 'endtime' },
        { text: 'Time (First time response)' },
        { text: 'Time Closed' },
        { text: 'Thread ID', value: 'thread_id' },
        { text: 'Post ID', value: 'postid' }
      ],
      tickets: [],
      exportloading: false,
      loading: true,
      offset: 0,
      limit: 10,
      total: 0,
      showAdd: false,
      groups: {},
      subgroups: {},
      tempFilter: {},

      selectedDueDate: {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      },
      items: [{ header: 'Select an option or create one' }],
      search: null,
      timer: null,
      tagediting: null,
      tags: [],
      showTable: true,
      filterTickets: [],
      view_ticket: '',
      gpfSatisfactionScores: {},
      pagelimit: [10, 20, 50],
      showExportTicket: false,
      selectedTicket: [],
      showSelectAllTransferTicketButton: false,
      showSelectAllCloseTicketButton: false,
      showDialogSelectAgent: false,
      showDialogCloseTicket: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent',
      isMonix: 'isMonix',
      currentLang: 'currentLang'
    }),
    ticketFormat() {
      return this.tickets
    },
    showFilter() {
      const result = []
      if (this.filter.channel) {
        result.push(`Channel: ${this.filter.channel}`)
      }
      if (this.filter.id) {
        result.push(`ID: ${this.filter.id}`)
      }
      if (this.filter.status.length > 0) {
        result.push(`Status: ${this.filter.status.join(', ')}`)
      }
      if (this.filter.group && this.filter.group.groupname !== 'All') {
        result.push(`Group: ${this.filter.group.groupname}`)
      }
      if (this.filter.assignadminid) {
        result.push(`Assgin To: ${this.filter.assignadminid}`)
      }

      if (this.filter.subgroup && this.filter.subgroup.id) {
        result.push(`Sub Group: ${this.filter.subgroup}`)
      }
      if (this.filter.admin && this.filter.admin !== 'all') {
        result.push(`Name: ${this.filter.admin}`)
      }
      if (this.filter.priority && this.filter.priority !== 'all') {
        result.push(`Priority: ${this.filter.priority}`)
      }
      if (this.tags.length) {
        result.push(`Tags: ${this.tags.map((el) => el.text)}`)
      }
      if (this.filter.selectedDate.start) {
        result.push(`Start Date: ${moment(this.filter.selectedDate.start).format('DD/MM/YYYY')}`)
      }
      if (this.filter.selectedDate.end) {
        result.push(`End Date: ${moment(this.filter.selectedDate.end).format('DD/MM/YYYY')}`)
      }
      if (this.selectedDueDate.start) {
        result.push(`Start Due Date: ${moment(this.selectedDueDate.start).format('DD/MM/YYYY')}`)
      }
      if (this.selectedDueDate.end) {
        result.push(`End Due Date: ${moment(this.selectedDueDate.end).format('DD/MM/YYYY')}`)
      }
      if (this.filter.subject) {
        result.push(`Subject: ${this.filter.subject}`)
      }
      if (this.filter.contact_name) {
        result.push(`Fullname: ${this.filter.contact_name}`)
      }
      if (this.filter.contact_email) {
        result.push(`Email: ${this.filter.contact_email}`)
      }
      return result
    },
    pages() {
      if (this.pagination.rowsPerPage == null || this.total == null) return 0

      return Math.ceil(this.total / this.pagination.rowsPerPage)
    },
    agentGroupOptions() {
      return this.loadingAgentGroup
        ? []
        : [
            {
              groupname: 'All',
              id: null
            },
            ...this.agentGroup
          ]
    },
    agentSubGroupOptions() {
      if (!this.filter.group) {
        return []
      }
      var subgroup = this.agentSubGroup.filter((el) => {
        return el.admingroupid == this.filter.group.id
      })
      return this.loadingAgentSubGroup
        ? []
        : [
            {
              subgroupname: 'All',
              id: null
            },
            ...subgroup
          ]
    },
    agentAdminOptions() {
      if (!this.filter.group || !this.filter.subgroup) {
        return []
      }
      var agents = this.agents.filter((el) => {
        return el.subgroupname == this.filter.subgroup.subgroupname
      })
      return this.loadingAgent
        ? []
        : [
            {
              name: 'All',
              adminid: null
            },
            ...agents
          ]
    },
    moment() {
      return moment
    },
    isShowSelectAll() {
      return true
    },
    selectedTicketId() {
      const selectedTicket = this.selectedTicket
      if (selectedTicket && selectedTicket.length > 0) {
        return selectedTicket.map((el) => {
          return { id: el.id, pageid: el.pageid }
        })
      } else {
        return []
      }
    }
  },
  watch: {
    pagination: {
      handler() {
        // this.getTickets()
      },
      deep: true
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }

          this.items.push(v)
        }

        return v
      })
    }
  },
  created() {
    momentDurationFormatSetup(moment)
  },

  async mounted() {
    this.filter.status =
      this.$localStorage.get(LOCAL_STORAGE_NAME.TICKET_STATUS_FILTER) &&
      this.$localStorage.get(LOCAL_STORAGE_NAME.TICKET_STATUS_FILTER) !== 'undefined'
        ? this.$localStorage.get(LOCAL_STORAGE_NAME.TICKET_STATUS_FILTER).split(',')
        : this.filter.status
    this.$root.$on('reloadTickets', () => {
      // your code goes here
      this.onSearch()
    })

    const vm = this
    vm.loading = true
    vm.showSelectAllTransferTicketButton = true

    try {
      const responseGroup = await this.getAdminGroup()
      const responseSubGroup = await this.getAdminSubGroup()
      if (responseGroup.data) {
        let group = {}
        responseGroup.data.map((el) => {
          group[el.id] = el
        })
        vm.groups = group
      }
      if (responseSubGroup.data) {
        let subgroup = {}
        responseSubGroup.data.map((el) => {
          subgroup[el.id] = el
        })
        vm.subgroups = subgroup
      }

      const filter = vm.initFilter()
      const response = await vm.getTickets(filter)
      if (response.data) {
        vm.tickets = response.data
        vm.total = response.total
      }
      if (!['114683640172785', '326180737483767'].includes(vm.selectedBot.pageid)) {
        vm.timer = setInterval(async () => {
          const filter = vm.initFilter()
          const response = await vm.getTickets(filter)
          if (response.data) {
            vm.tickets = response.data
            vm.total = response.total
            if (vm.selectedBot && vm.selectedBot.type === 'gpf') {
              notificationNewTicket({
                tickets: response.data,
                timeInterval: INTERVAL_TICKET
              })
            }
          }
        }, INTERVAL_TICKET)
      }
    } catch (error) {
      console.error(error)
    }
    vm.loading = false
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  methods: {
    diffSecond(endDate, startDate) {
      const diff = moment(endDate).diff(startDate)
      return diff / 1000
    },
    toTimer: (value) => {
      let totalSeconds = value
      if (typeof totalSeconds == 'string') {
        totalSeconds = parseInt(totalSeconds)
      }
      const seconds = Math.floor(totalSeconds) % 60
      const minutes = Math.floor(totalSeconds / 60) % 60
      const hours = Math.floor(totalSeconds / 60 / 60)
      const padZero = (number) => (number > 99 ? number : number.toString().padStart(2, '0'))
      return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`
    },
    handleCloseHistory() {
      this.historyData = null
      this.showHistory = false
    },
    async handleShowHistory(id) {
      const vm = this
      vm.loadingHistory = true
      vm.showHistory = true
      await vm.handleGetTicketHistory(id)
    },
    async handleGetTicketHistory(id) {
      const vm = this
      try {
        const response = await api.ticket2GetTicketHistory({
          pageId: vm.selectedBot.pageid,
          ticketId: id
        })

        if (response) {
          vm.historyData = response.history
          vm.loadingHistory = false
        }
      } catch (error) {
        vm.loadingHistory = false
        console.error(error)
        return
      }
    },
    formatSec(endDate, startDate) {
      try {
        const totalMilliSeconds = moment(endDate).diff(startDate)
        const formatted = moment.duration(totalMilliSeconds).format('h [hr] m [min] s [sec]')
        return formatted
      } catch (error) {
        return '-'
      }
    },
    handleOpenEditTicket(id) {
      if (!['qa', 'reporter'].includes(this.$store.state.privilege.role)) {
        this.$refs['editticket_' + id].openModal()
      }
    },
    async exportTicket(callback) {
      await this.$store.dispatch('loading')
      await this.exportData(callback)
      await this.$store.dispatch('loading')
      this.showExportTicket = false
    },
    numberWithCommas(x) {
      x = x.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    },
    onSelectedPost(val) {
      if (val) {
        this.filter.postid = val
      }
    },
    initFilter() {
      let filter = {
        status: this.filter.status.join(',')
      }
      if (this.filter.selectedDate.start) {
        filter.starttime = moment(this.filter.selectedDate.start).format('YYYY-MM-DD')
      }

      if (this.filter.selectedDate.end) {
        filter.endtime = moment(this.filter.selectedDate.end).format('YYYY-MM-DD')
      }
      if (this.$store.state.privilege) {
        this.view_ticket = this.$store.state.privilege.view_ticket
        if (this.view_ticket == 'all') {
          // dont do shit
        } else if (this.view_ticket == 'only_me') {
          Object.assign(filter, {
            assignadminid: this.$store.state.userid
          })
          if (this.$store.state.admingroupid || this.$store.state.admingroupid === 0) {
            this.filter.group = this.groups[this.$store.state.admingroupid]
          }
          if (this.$store.state.adminsubgroupid || this.$store.state.adminsubgroupid === 0) {
            this.filter.subgroup = this.subgroups[this.$store.state.adminsubgroupid]
          }
          if (this.agents) {
            this.filter.admin = this.agents.find((el) => el.adminid == this.$store.state.userid)
          }
        } else if (this.view_ticket == 'only_group') {
          Object.assign(filter, {
            assigngroupid: this.$store.state.admingroupid
          })
          if (this.$store.state.admingroupid || this.$store.state.admingroupid === 0) {
            this.filter.group = this.groups[this.$store.state.admingroupid]
          }
        } else if (this.view_ticket == 'only_subgroup') {
          Object.assign(filter, {
            assignsubgroupid: this.$store.state.adminsubgroupid
          })
          if (this.$store.state.admingroupid || this.$store.state.admingroupid === 0) {
            this.filter.group = this.groups[this.$store.state.admingroupid]
          }
          if (this.$store.state.adminsubgroupid || this.$store.state.adminsubgroupid === 0) {
            this.filter.subgroup = this.subgroups[this.$store.state.adminsubgroupid]
          }
        }
      }
      this.tempFilter = { ...this.filter }
      return filter
    },
    getDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    async onChange(val) {
      if (val.limit !== this.limit || val.offset !== this.offset) {
        this.loading = true
        try {
          var filter = this.formatFilter()
          this.limit = val.limit
          this.offset = val.offset
          var response = await this.getTickets(filter)
          if (response.data) {
            this.$nextTick(() => {
              this.tickets = response.data
            })
            this.total = response.total
          }
        } catch (error) {
          console.error(error)
        }
        this.loading = false
        this.showSearch = false
      }
    },
    clearSearch() {
      if (this.selectedBot.pageid == '101760532365601') {
        this.$refs['selcct-post'].clearPost()
      }
      this.filter = { ...this.tempFilter }
      this.filter.selectedDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      }
      this.selectedDueDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      }
      this.onSearch()
    },
    async exportData(options) {
      const vm = this
      try {
        const filename = 'ticketlist'
        vm.exportloading = true

        var filter = this.formatFilter()
        vm.exportloading = true
        const { ...filterOptions } = options
        var response = await this.getTickets(filter, false, filterOptions)
        let tickets = null
        if (response.data) {
          tickets = response.data
        }

        const json = tickets.map((el) => {
          let objData = null
          let wrapUpRoute = []
          if (el.wrap_up_route) {
            try {
              wrapUpRoute = el.wrap_up_route.split(' || ')
            } catch (error) {
              wrapUpRoute = []
            }
          }
          const isClosed = ['closed with survey', 'closed without survey'].includes(el.status)
          objData = {
            id: el.id ? el.id : '-',
            priority: el.priority ? el.priority : '-',
            mood: el.mood ? el.mood : '-',
            status: el.status ? el.status : '-',
            customer_name: el.first_name
              ? `${el.first_name}${el.last_name ? ` ${el.last_name}` : ''}`
              : '-',
            page: el.customer_page_name ? el.customer_page_name : '-',
            channel: el.app || '-',
            platform_type:
              el.platform_type === 'inbox'
                ? this.$t('all_in_one_chat.inbox')
                : el.platform_type === 'page'
                ? this.$t('all_in_one_chat.post')
                : '-',
            first_assign_admin_id: el.first_assign_admin_id ? el.first_assign_admin_id : '-',
            transfer_by: el.transfer_ticket_by ? el.transfer_ticket_by : 'system',
            assign_adminid: el.assignadminid ? el.assignadminid : '-',
            group: this.groups[el.assigngroupid] ? this.groups[el.assigngroupid].groupname : '-',
            subgroup: this.subgroups[el.assignsubgroupid]
              ? this.subgroups[el.assignsubgroupid].subgroupname
              : '-',
            close_by: el.assignadminid && isClosed ? el.assignadminid : '-',
            subject: el.subject ? el.subject : '-',
            details: el.details ? el.details : '-',
            comment: el.comment ? el.comment : '-',
            create_date: el.starttime ? moment(el.starttime).format('DD/MM/YYYY') : '-',
            start_time: el.starttime ? moment(el.starttime).format('DD/MM/YYYY HH:mm') : '-',
            assign_to_agent: el.assign_ticket_timestamp
              ? moment(el.assign_ticket_timestamp).format('DD/MM/YYYY HH:mm')
              : '-',
            admin_firsttime_response: el.adminfirstresponsetime
              ? moment(el.adminfirstresponsetime).format('DD/MM/YYYY HH:mm')
              : '-',
            end_time: el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
            time_first_response:
              el.adminfirstresponsetime && el.assign_ticket_timestamp
                ? this.toTimer(
                    this.diffSecond(el.adminfirstresponsetime, el.assign_ticket_timestamp)
                  )
                : '-',
            time_closed:
              el.starttime && el.endtime
                ? this.toTimer(this.diffSecond(el.endtime, el.starttime))
                : '-',
            time_to_transfer: el.transfer_ticket_timestamp
              ? moment(el.transfer_ticket_timestamp).format('DD/MM/YYYY HH:mm')
              : '-',
            Tags: el.tags ? el.tags : '-',
            wrap_up_l1: wrapUpRoute[0] ? wrapUpRoute[0] : '-',
            wrap_up_l2: wrapUpRoute[1] ? wrapUpRoute[1] : '-',
            wrap_up_l3: wrapUpRoute[2] ? wrapUpRoute[2] : '-',
            wrap_up_l4: wrapUpRoute[3] ? wrapUpRoute[3] : '-',
            sla_status: el.sla_status ? el.sla_status : '-',
            thread_id: el.thread_id || '-',
            postid: el.postid || '-'
          }
          return objData
        })

        const heading = [
          [
            'Ticket ID',
            'Priority',
            'Mood',
            'Status',
            'Customer Name',
            'Page',
            'Channel',
            'Platform Type',
            'First Assign Agent',
            'Transfer By',
            'Assign To',
            'Group',
            'Subgroup',
            'Closed By',
            'Topic',
            'Detail',
            'Comment',
            'Create Date',
            'Start Time',
            'Assign to agent',
            'First Time Response',
            'End Time',
            'Time (First time response)',
            'Time Closed',
            'Time To Transfer',
            'Tags',
            'Wrap up L1',
            'Wrap up L2',
            'Wrap up L3',
            'Wrap up L4',
            'SLA Status',
            'Thread ID',
            'Post ID'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, json, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `${filename}.xlsx`)

        vm.exportloading = false
      } catch (error) {
        vm.exportloading = false
        console.error(error)
      }
    },

    goToLivechat: async function (user, app) {
      try {
        const context = user.context == 'contactadmin' ? 'admin' : 'bot'
        let queryParams = {
          userid: user.userid,
          pageid: user.pageid,
          user: context,
          app: app,
          inbox: context
        }
        if (user.thread_id) {
          queryParams.platform_thread_id = user.thread_id
        }
        if (user.postid) {
          queryParams.platform_post_id = user.postid
        }
        if (user.platform_type) {
          queryParams.platform_type = user.platform_type
        }
        const routeData = this.$router.resolve({
          name: 'livechat',
          path: `/${this.currentLang}/livechat`,
          query: queryParams
        })
        const response = await allInOneChatApi.postAdminRead({
          data: {
            inbox_id: user.inbox_id,
            user_id: user.userid,
            page_id: user.pageid
          }
        })
        const { status } = response
        if (status === 200) {
          window.location.href = `${window.location.origin}${routeData.href}`
        }
      } catch (error) {
        console.error(error)
      }
    },
    durationTime(start, end) {
      const startTime = start
      const endTime = end
      const minutes = moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm').diff(moment(startTime, 'YYYY/MM/DD HH:mm')))
        .asMinutes()
        .toFixed(2)
      return minutes
    },
    addDurationUnit(minutes) {
      return moment.duration(parseFloat(minutes), 'minutes').format('h [hr] m [min]')
    },
    remainingTime(end) {
      const startTime = moment()
      const endTime = moment(end)
      if (startTime.isBefore(endTime)) {
        const minutes = moment.duration(endTime.diff(startTime)).asMinutes().toFixed(2)
        return moment.duration(parseFloat(minutes), 'minutes').format('h [hr] m [min]')
      } else {
        return 0
      }
    },
    async onSearch() {
      const vm = this
      try {
        let filter = null
        filter = vm.formatFilter()
        // if (value) {
        //   filter = value
        //   vm.filter = value
        // } else {
        //   filter = vm.formatFilter()
        // }

        this.$localStorage.set(LOCAL_STORAGE_NAME.TICKET_STATUS_FILTER, filter.status)

        vm.offset = 0
        vm.page = 1
        vm.loading = true
        const response = await vm.getTickets(filter)
        vm.loading = false

        if (response.data) {
          vm.$nextTick(() => {
            vm.tickets = response.data
          })
          vm.total = response.total
        }
        vm.showSearch = false
      } catch (error) {
        vm.loading = false
        vm.showSearch = false
        console.error(error)
      }
    },
    formatFilter() {
      let data = {}

      if (this.filter.channel) {
        data.channel = this.filter.channel
      }
      if (this.filter.id) {
        data.id = this.filter.id
      }
      if (this.filter.status) {
        data.status = this.filter.status.toString()
      }
      if (this.filter.contact_phone) {
        data.contact_phone = this.filter.contact_phone
      }

      if (this.filter.group && this.filter.group.id != null) {
        data.assigngroupid = this.filter.group.id
      }

      if (this.filter.assignadminid) {
        data.assignadminid = this.filter.assignadminid
      }

      if (this.filter.subgroup && this.filter.subgroup.id != null) {
        data.assignsubgroupid = this.filter.subgroup.id
      }
      if (this.filter.admin && this.filter.admin != null) {
        data.assignadminid = this.filter.admin
      }

      if (this.filter.selectedDate.start) {
        data.starttime = moment(this.filter.selectedDate.start).format('YYYY-MM-DD')
      }

      if (this.filter.selectedDate.end) {
        data.endtime = moment(this.filter.selectedDate.end).format('YYYY-MM-DD')
      }

      if (this.selectedDueDate.start) {
        data.startDueDate = moment(this.selectedDueDate.start).format('YYYY-MM-DD')
      }

      if (this.selectedDueDate.end) {
        data.endDueDate = moment(this.selectedDueDate.end).format('YYYY-MM-DD')
      }

      if (this.filter.priority && this.filter.priority.value != null) {
        data.priority = this.filter.priority.value
      }
      if (this.filter.sort && this.filter.sort.value != null) {
        data.orderby = this.filter.sort.value
      }
      if (this.filter.subject) {
        data.subject = this.filter.subject
      }
      if (this.filter.contact_name) {
        data.contact_name = this.filter.contact_name
      }
      if (this.filter.contact_email) {
        data.contact_email = this.filter.contact_email
      }

      if (this.filter.postid) {
        data.postid = this.filter.postid
      }

      if (this.filter.thread_id) {
        data.thread_id = this.filter.thread_id
      }

      if (this.filter.platform_type) {
        data.platform_type = this.filter.platform_type
      }

      if (this.filter.botreply == true || this.filter.botreply == false) {
        data.botreply = this.filter.botreply
      }

      if (this.filter.search_page_id) {
        data.search_page_id = this.filter.search_page_id
      }

      if (this.tags && this.tags.length > 0) {
        var tags = this.tags.map((el) => {
          return el.text
        })
        data.tags = tags.join(',')
      }
      return data
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },

    onEditTicket(ticket) {
      const vm = this
      const index = this.tickets.findIndex((el) => el.id == ticket.id)
      this.$set(vm.tickets, index, { ...vm.tickets[index], ...ticket })
    },
    getTicketById(id) {
      const data = {
        id: id,
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getTicketById(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTickets(filter = [], allpage = false, options = null) {
      let data = {
        pageid: this.selectedBot.pageid,
        role: this.$store.state.privilege && this.$store.state.privilege.role,
        ...filter
      }
      if (!allpage) {
        Object.assign(data, { offset: this.offset })
        Object.assign(data, { limit: this.limit })
      }
      if (options) {
        data = { ...data, ...options }
      }

      return new Promise((resolve, reject) => {
        api.getTickets(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getAdminGroup() {
      const pageid = this.selectedBot.pageid
      return new Promise((resolve, reject) => {
        api.getAdminGroup({ pageid }, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getAdminSubGroup() {
      const pageid = this.selectedBot.pageid
      return new Promise((resolve, reject) => {
        api.getAdminSubGroup({ pageid }, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async handleTransferSelectedTicket() {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          text: 'คุณต้องการ Transfer ticket ใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง',
          reverseButtons: true
        })

        if (result.value) {
          vm.updateStatusCloseMultiTicket()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleCloseSelectedTicket() {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          text: 'คุณต้องการ ปิดทิกเก็ต ใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง',
          reverseButtons: true
        })

        if (result.value) {
          vm.updateStatusCloseMultiTicket()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async updateStatusCloseMultiTicket() {
      const vm = this
      try {
        const pageId = vm.selectedBot.pageid
        const data = {
          tickets: vm.selectedTicketId.map((el) => ({ id: el.id }))
        }

        const response = await api.ticketCloseMultiTicket(data, pageId)
        if (response && response.message === 'Closed success') {
          vm.selectedTicket = []
          vm.onSearch()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleTransferTicket(value) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          html: `<strong>${vm.$t('confirm_transfer_ticket')} <br/>${value.agent} ${vm.$t(
            'confirm_transfer_ticket_1'
          )}</strong>`,
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.transferTickets(value)
          vm.$store.dispatch('loading')

          if (response && response.status === 204) {
            vm.selectedTicket = []
            vm.onSearch()

            vm.$swal.fire({
              type: 'success',
              html: `<strong>${vm.$t('transfer_ticket_success')}  <br/>  ${value.agent} ${vm.$t(
                'transfer_ticket_success_1'
              )} </strong>`,
              confirmButtonText: vm.$t('ok')
            })
          }
        } else {
          vm.showDialogSelectAgent = true
        }
      } catch (error) {
        console.error(error)
      }
    },
    async transferTickets(value) {
      const vm = this

      try {
        const ticketListByPageId = vm.selectedTicketId.reduce((prev, curr) => {
          if (prev[curr.pageid]) {
            prev[curr.pageid].push(curr.id)
          } else {
            prev[curr.pageid] = [curr.id]
          }
          return prev
        }, [])

        const keys = Object.keys(ticketListByPageId)
        const ticketUpdatePromises = []

        for (const key of keys) {
          if (key && Object.hasOwnProperty.call(ticketListByPageId, key)) {
            ticketUpdatePromises.push(
              this.saveBatchTickets(
                key,
                ticketListByPageId[key],
                value.agent,
                value.group.id,
                value.subgroup.id
              )
            )
          }
        }

        const ticketUpdateResults = await Promise.all(ticketUpdatePromises)
        const response = ticketUpdateResults.reduce((prev, curr) => {
          if (curr && curr.status === 204) {
            prev.status = 204
          }
          return prev
        }, {})

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async saveBatchTickets(page_id, ids, agent, assigngroupid, assignsubgroupid) {
      try {
        const data = {
          page_id: page_id,
          assign_to: agent,
          ids: ids,
          assigngroupid: assigngroupid ? Number(assigngroupid) : '',
          assignsubgroupid: assignsubgroupid ? Number(assignsubgroupid) : ''
        }

        const response = await ttbApi.postTransferMultiTicket({ data: data })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async handleCloseTicket(value) {
      try {
        const result = await this.$swal.fire({
          type: 'warning',
          title: this.$t('confirm_close_ticket'),
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          this.handleSelectedCloseTicket(value)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleSelectedCloseTicket(value) {
      try {
        this.$store.dispatch('loading')
        const tickets = this.selectedTicketId.map((ticket) =>
          this.ticketFormat.find((item) => item.id === ticket.id)
        )
        const ticketIds = tickets.map((ticket) => ticket.id)
        const userIds = tickets.map((ticket) => ticket.userid)
        const payload = {
          page_id: this.selectedBot.pageid,
          user_ids: [...new Set(userIds)],
          ticket_ids: ticketIds,
          ...value
        }
        const response = await ticketApi.putCloseMultiSelect({ data: payload })
        const { status } = response
        if (status === 200) {
          this.$swal.fire({
            type: 'success',
            title: this.$t('Success'),
            confirmButtonText: this.$t('ok')
          })
          this.selectedTicket = []
          this.onSearch()
          this.showDialogCloseTicket = false
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box-status {
  border-radius: 1rem;
  color: #fff;
}

.font-total-case {
  font-weight: bold !important;
  font-size: 36px;
}

.font-bold {
  font-weight: bold !important;
  font-size: 30px;
}

.font-bold {
  font-weight: bold !important;
  font-size: 26px;
}

.bg-total {
  background: rgb(0, 56, 204);
  background: linear-gradient(
    180deg,
    rgba(0, 56, 204, 1) 0%,
    rgba(0, 56, 204, 1) 49%,
    rgba(107, 108, 255, 1) 100%
  );
}

.bg-pending {
  background: rgb(255, 148, 52);
  background: linear-gradient(
    180deg,
    rgba(255, 148, 52, 1) 0%,
    rgba(255, 158, 101, 1) 57%,
    rgba(255, 172, 146, 1) 100%
  );
}

.bg-answered {
  background: rgb(52, 157, 140);
  background: linear-gradient(
    180deg,
    rgba(52, 157, 140, 1) 0%,
    rgba(59, 204, 129, 1) 49%,
    rgba(127, 195, 153, 1) 100%
  );
}

.bg-closed {
  background: rgb(104, 224, 230);
  background: linear-gradient(
    0deg,
    rgba(104, 224, 230, 1) 0%,
    rgba(68, 197, 237, 1) 49%,
    rgba(90, 165, 232, 1) 100%
  );
}

.bg-cancled {
  background: rgb(251, 135, 222);
  background: linear-gradient(
    180deg,
    rgba(251, 135, 222, 1) 0%,
    rgba(232, 179, 255, 1) 49%,
    rgba(238, 183, 255, 1) 100%
  );
}

.bg-cancledbycustomer {
  background: rgb(255, 84, 114);
  background: linear-gradient(
    180deg,
    rgba(255, 84, 114, 1) 0%,
    rgba(213, 82, 146, 1) 49%,
    rgba(157, 89, 159, 1) 100%
  );
}

.custom-table {
  /deep/ {
    .v-table__overflow {
      overflow: auto;
      /* max-height: 50dvh; */
    }

    thead {
      position: sticky;
      top: 0;
      background-color: inherit;
      z-index: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Dashboard.vue